(function () {


	angular.module('app.widgets')
	.directive('plaNavBar', plaNavBar);

	plaNavBar.$inject = ['UserInfoService'];

	function plaNavBar(UserInfoService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/widgets/navbar.html',
            link: function(scope, element, attrs) {
				jQuery(window).resize();
				_topNav();
				userInfoChanged(scope, UserInfoService);
              }
        }
    }

    /** 01. Top Nav
 **************************************************************** **/
function _topNav() {
	var addActiveClass = false;

	jQuery("#topMain li.dropdown > a, #topMain li.dropdown-submenu > a").bind("click", function(e) {
		if(jQuery(this).attr('href') == '#') {
			e.preventDefault();
		}

		e.stopPropagation();

		if(jQuery(window).width() > 979) {
			return;
		}


		addActiveClass = jQuery(this).parent().hasClass("resp-active");
		jQuery("#topMain").find(".resp-active").removeClass("resp-active");

		if(!addActiveClass) {
			jQuery(this).parents("li").addClass("resp-active");
        }

		return;

	});

	// Drop Downs - do not hide on click
	// jQuery("#topHead .dropdown-menu, #topNav .mega-menu .dropdown-menu").bind("click", function(e) {
	// 	e.stopPropagation();
	// });

	jQuery(window).scroll(function() {

		if(jQuery(window).width() > 1006) {
			topMain(); // on scroll
		}

	});	
	
	if(jQuery(window).width() > 1006) {
		topMain(); // on load
	}



		// #topHead Fixes
		window._headHeight		= 81;
		window._headHeightSmall	= 30;

		function _topNavCalibrate() {

			if(jQuery("#topHead").length > 0) {
				window._headHeight 		= jQuery("header#topHead").outerHeight() + jQuery("header#topNav").outerHeight() - 10;
				window._headHeightSmall	= 66;

				jQuery('#wrapper').css({"padding-top":window._headHeight + "px"});
				jQuery('#topHead').removeClass('fixed').addClass('fixed');

				if(jQuery('#header_shadow').length > 0) {
					jQuery('#header_shadow').css({"top":window._headHeight + "px"});
				}

			} else {

				if(jQuery(window).width() < 1006) {
					//jQuery('#wrapper').css({"margin-top":"-30px"});
					jQuery('#header_shadow').css({"top":"40px"});
				} else {
					jQuery('#wrapper').css({"margin-top":"0px"});

					// From mobile back to desktop - do not leave the shadow behing
					if(jQuery(window).scrollTop() > 3) {
						jQuery('#header_shadow').css({"top":"60px"});
					} else {
						jQuery('#header_shadow').css({"top":"80px"});
					}
				}

			}

		}

		// recalibrate menu (mobile = slim mode) on resize
		jQuery(window).resize(function() {
			_topNavCalibrate();
		});	_topNavCalibrate();


	// scoll is on top!
	window.topNavSmall = false;


	function topMain() {
		var _scrollTop 		= jQuery(document).scrollTop();

		if(window.topNavSmall === false && _scrollTop > 0) {
		
			jQuery('header#topNav div.nav-main-collapse').addClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'60px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'6px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'0'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'margin-top':'-10px'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeightSmall + 'px'},400);/* just a little visible */
			}

			window.topNavSmall = true;
		} 

		if(window.topNavSmall === true && _scrollTop < 3) {
			jQuery('header#topNav div.nav-main-collapse').removeClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'81px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'16px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'8px'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'line-height':'50px', 'margin-top':'0'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeight + 'px'},400);
			}

			window.topNavSmall = false;
		}

	}
};

function userInfoChanged(scope, UserInfoService){
	scope.$watch(function(){
		return UserInfoService.userInfo.isAuthenticated;
	}, function(){
		scope.isUserAuthenticated = UserInfoService.userInfo.isAuthenticated;
		scope.userName = UserInfoService.userInfo.userName;
		SetPermisos(UserInfoService.userInfo.permisos);
	});

	function SetPermisos(permisos){
		
		if(!permisos) return;

		permisos.forEach((element, index, array) => {
			switch(element.permisoId){
				case 1: //Administrar
					scope.permisoAdministrar = element.ver;
					break;
				case 2: //Usuarios
					scope.permisoUsuarios = element.ver;
					break;
				case 3: //Grupos
					scope.permisoGrupos = element.ver;
					break;
				case 5: //Mantenimientos
					scope.permisoMantenimientos = element.ver;
					break;
				case 6: //Moviles
					scope.permisoMoviles = element.ver;
					break;
				case 7: //Aeronaves
					scope.permisoAeronaves = element.ver;
					break;
				case 8: //Pilotos
					scope.permisoPilotos = element.ver;
					break;
				case 9: //Choferes
					scope.permisoChoferes = element.ver;
					break;
				case 10: //Empresas Fumigadoras
					scope.permisoEmpresasFumigadoras = element.ver;
					break;
				case 11: //Clientes
					scope.permisoClientes = element.ver;
					break;
				case 12: //Proyectos
					scope.permisoProyectos = element.ver;
					break;
				case 13: //Servicios
					scope.permisoServicios = element.ver;
					break;
				case 14: //Contratos
					scope.permisoContratos = element.ver;
					break;
				case 15: //Parametros
					scope.permisoParametros = element.ver;
					break;
				case 16: //Ordenes de Servicio
					scope.permisoOrdenesServicio = element.ver;
					break;
				case 17: //Centros de Costo
					scope.permisoCentrosCosto = element.ver;
					break;
				case 20: //Reportes
					scope.permisoReportes = element.ver;
					break;
				case 21: //Reportes Contratos
					scope.permisoReportesContratos = element.ver;
					break;
				case 22: //Reportes Ordenes de Servicio
					scope.permisoReportesOrdenes = element.ver;
					break;
			}				
		});

	};
};

})();